import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActivatedRoute, ActivatedRouteSnapshot, ExtraOptions, PreloadAllModules, Route, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { LayoutComponent } from './layout/layout.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorComponent } from './modules/error-component/error.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OrderInterceptor } from './order-intercept';
import { OrderHandleSessionService } from './modules/shop-orders/services/order-session.service';
import { FuseConfirmationModule } from '@fuse/services/confirmation';
import { SharedModule } from './shared/shared.module';
import { PostCompraDataResolver } from './modules/post-compra-register-flow/post-compra-register.resolver';


const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    useHash: false //  config to fix s3 handler route
};

const appRoutes: Route[] = [
    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            //{path: '', loadChildren: () => import('app/modules/home/home.module').then(m => m.LandingHomeModule)},
            {path: 'c', loadChildren: () => import('app/modules/store/store.module').then(m => m.StoreModule)},
            {path: 's', loadChildren: () => import('app/modules/store/store.module').then(m => m.StoreModule)},
            
            // bookings flow
            {path: 'b', loadChildren: () => import('app/modules/bookings-purchase-flow/bookings-purchase.module').then(m => m.BookingsPurchaseFlowModule)},
                        
            {path: 'tickets', loadChildren: () => import('app/modules/shop-orders/shop-orders.module').then(m => m.ShopModule)},
            {path: 'error', component: ErrorComponent},

     
            //
            {
                path: 'p', 
                loadChildren: () => import('app/modules/post-compra-register-flow/post-compra-register.module').then(m => m.PostCompraRegisterModule),
            },

            // shop flow v2 (mobile-first) — docs/shop-flow-v2
            {path: '', loadChildren: () => import('app/modules/shop-flow-v2/shop-flow-v2.module').then(m => m.ShopFlowV2Module)},
            


        ]
    }
];

@NgModule({
    declarations: [
        AppComponent,
        ErrorComponent,
    ],

    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,
        SharedModule,
        MatSnackBarModule,
        FuseConfirmationModule


        
    ],

    bootstrap   : [
        AppComponent
    ],

    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy }, // Usa la estrategia de ubicación de HTML5 para resovler s3 paths
        OrderHandleSessionService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: OrderInterceptor,
            multi   : true
        },
        
      ]
    
})
export class AppModule
{
}
